import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/Badge";
import { Card } from "@/components/ui/Card";
import {
  calculatePowerScore,
  getCharacterSubtitle,
  getCharacterTitle,
} from "@/features/characters/character-utils";
import { formatDateTime } from "@/lib/format";
import type { Character } from "@/features/characters/types";

interface CharacterCardProps {
  character: Character;
}

export function CharacterCard({ character }: CharacterCardProps) {
  return (
    <Card
      title={getCharacterTitle(character)}
      subtitle={getCharacterSubtitle(character)}
      action={<Badge tone="moss">Poder {calculatePowerScore(character)}</Badge>}
      className="h-full"
    >
      <div className="space-y-5">
        <p className="line-clamp-3 min-h-16 text-sm leading-7 text-mist">
          {character.summary || "Sem resumo ainda. Abra a ficha para detalhar este herói."}
        </p>
        <div className="grid gap-3 text-sm text-mist sm:grid-cols-2">
          <p>
            <span className="text-parchment">Última atualização:</span>{" "}
            {formatDateTime(character.updatedAt)}
          </p>
          <p>
            <span className="text-parchment">Origem:</span> {character.origin}
          </p>
        </div>
        <Link
          to={`/characters/${character.id}`}
          className="inline-flex w-full items-center justify-center rounded-xl border border-gold/25 bg-parchment/10 px-4 py-2.5 text-sm font-semibold tracking-wide text-parchment transition hover:border-gold/45 hover:bg-parchment/16"
        >
          Abrir ficha
        </Link>
      </div>
    </Card>
  );
}
